import { render, staticRenderFns } from "./TestsTable.vue?vue&type=template&id=c7d65caa"
import script from "./TestsTable.vue?vue&type=script&lang=js"
export * from "./TestsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports